module.exports = __webpack_public_path__ + "img/timytoys0.c1d8f040.png";